import { Breadcrumbs, PageActions, PageLayout, Spinner } from 'components'
import { COLLECTIONS, PATHS } from '__constants__'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import { CustomerAdvancedView } from 'domains/Customer/components'
import { useListenDocument } from 'services/api/firebase'
import { useTranslations } from 'hooks'

const CustomerShowPage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()
  /* Getting params from router */
  const params = useParams()
  /* Fetching document data from useDocument hook */
  const [customer, loading] = useListenDocument({
    ref: COLLECTIONS.CUSTOMERS + '/' + params.customerId
  })

  /* Configuring page header */
  const headingProps = {
    title: customer?.firstName || t('Customer show'),
    textAlign: 'left'
  }

  /* Getting id from params */
  const { customerId } = params

  /* Configuring page actions */
  const actions = { edit: !!PATHS.AUTHENTICATED.CUSTOMER_EDIT }

  /* Function to handle back click */
  const handleBack = () => navigate(-1)
  /* Handling opening of the edit page */
  const handleEdit = () => {
    const pathParams = { customerId }
    const path = generatePath(PATHS.AUTHENTICATED.CUSTOMER_EDIT, pathParams)
    navigate(path)
  }

  return (
    <PageLayout
      actions={<PageActions actions={actions} onEdit={handleEdit} />}
      onBack={handleBack}
      breadcrumbs={<Breadcrumbs />}
      headingProps={headingProps}
      area="customer">
      {loading ? (
        <Spinner height="70vh" text={t('Customer loading')} />
      ) : (
        <>
          <CustomerAdvancedView customer={customer} />
        </>
      )}
    </PageLayout>
  )
}

export default CustomerShowPage
